module.exports = __webpack_public_path__ + "img/Office5.ab49c295.jpg";